import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { observable, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import DocumentType from "./api-interfaces/documentType.interface";
import { HelperService } from "../helperService";
import { PersonType } from "./api-interfaces/customerBasicData.interface";

@Injectable({
    providedIn: 'root'
})
export class APIDocumentTypeService {

    ApiURL: string = "";

    constructor(private http: HttpClient, public helperService: HelperService) {
        // TODO: create environment variable
        this.ApiURL = environment.documentTypesUrl +'DocumentType'
    }

    public GetPersonTypeByCountryId(countryId: number): Observable<PersonType[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);        
        const body = {countryId: countryId}
        return this.http.post<PersonType[]>(`${this.ApiURL}/GetPersonTypeByCountryId`, body, {headers});
    }
    public GetDocumentTypeByCountryIdByPersonId(countryId: number,personTypeId: number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);       
        const body = {
          countryId: countryId,
          personTypeId: personTypeId
        }
        return this.http.post(`${this.ApiURL}/GetDocumentTypeByCountryIdByPersonId`, body, {headers});
    }
    public GetByCountryId(id): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
       return this.http.get(`${this.ApiURL}/GetByCountryId/${id}`, {headers});
    }

    public getAllDocumentTypes(): Observable<DocumentType[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get<DocumentType[]>(this.ApiURL, requestOptions);
    }

    public getDocumentTypeById(documentTypeId): Observable<DocumentType>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get<DocumentType>(this.ApiURL + "/" + documentTypeId, requestOptions);
    }
}


